import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface BackupListDialogResult {
  load: boolean;
  filename: string;
}

@Component({
  selector: 'app-backup-list',
  templateUrl: './backup-list.component.html',
  styleUrls: ['../shared/styles/styles.css'],
})
export class BackupListComponent {
  selectedFile: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<BackupListComponent>) {}

  close() { this.dialogRef.close(this.createDialogResult(true)); } //prettier-ignore
  cancel() { this.dialogRef.close(this.createDialogResult(false))} //prettier-ignore

  private createDialogResult(load: boolean): BackupListDialogResult {
    const fileName = this.getFileNameWithoutExtension();
    if (load) load = fileName.length > 0 ? true : false;

    return { load: load, filename: fileName };
  }

  private getFileNameWithoutExtension(): string {
    return this.selectedFile.length > 0 ? this.selectedFile.substring(0, this.selectedFile.length - 5) : '';
  }
}
